export default __webpack_public_path__ + "images/1fe6e5ad6ec0c7a1564f3471812273c1-washington_dc_desktop.webp";